import { render } from "./messages.vue?vue&type=template&id=2f3e98ab&scoped=true"
const script = {}

import "./messages.vue?vue&type=style&index=0&id=2f3e98ab&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\viglacera\\nhathau\\fe\\source005\\vig_contructor_fe_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3e98ab"]])

export default __exports__